import React, {Component} from "react";
import {connect} from "react-redux";
import {Grid3x3} from "@mui/icons-material";
import {morphleBaseTheme1} from "../themes";
import {updateGridStatus} from "../../../redux_actions/maps.state.action";
import {IconButton, Stack, Tooltip} from "@mui/material";
import VectorSource from "ol/source/Vector";
import GridReference from "ol-ext/control/GridReference";
import {Stroke, Style, Text} from "ol/style";
import {isOpenLayersMap, removeGridControls} from "../utils/map_utils";
import {requestOsdFeature} from "../openseadragon/viewerSelection";
import Graticule from "ol-ext/control/Graticule";
import {notifySuccess} from "../utils/display.notification";
import VectorLayer from "ol/layer/Vector";
import Circle from "ol/geom/Circle";
import Feature from "ol/Feature";
import {maxZIndex, responsiveLayers} from "../../../utils/const";

class GridOverlay extends Component {

	constructor(props) {
		super(props);

		this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
			(document.documentElement.clientWidth < document.documentElement.clientHeight);

		this.circleLayerRef = React.createRef();
	}

	toggleGrid = () => requestOsdFeature('grid_overlay').then(proceed => {
		if (proceed && isOpenLayersMap(this.props.slidemap))
			this.props.dispatch(updateGridStatus(this.props.activeMapId, !this.props.gridState.grid));
	});

	disableMessage = (componentDisabled) => componentDisabled && notifySuccess('grid', "Static Grid disabled for non-zero Rotation");

	drawGrid = () => {
		let extent = this.props.gridState.fullExtent ? this.props.slidemap.getView().getProjection().getExtent() :
			this.props.slidemap.getView().calculateExtent(this.props.slidemap.getSize());

		let fullWidth = extent[2] - extent[0];
		let fullHeight = extent[3] - extent[1];

		let gridCols = fullWidth * this.props.uperpixel / this.props.gridState.spacing;
		let gridRows = fullHeight * this.props.uperpixel / this.props.gridState.spacing;

		let gridRef = new GridReference({
			style: new Style({
				stroke: new Stroke({
					color: this.props.gridState.color,
					width: this.props.gridState.width,
				}),
			}),
			extent,
			size: [gridCols, gridRows],
			source: new VectorSource({
				overlaps: true,
			}),
		});


		gridRef.getHIndex = gridRef.getVIndex = index =>
			this.props.gridState.stepCord && index % this.props.gridState.stepCord === 0 ? index : '';
		this.props.slidemap.addControl(gridRef);
		if (this.props.gridState.circleLayer) {
			let circleLayer = this.drawCircleLayer(fullHeight, gridRows, gridCols, fullWidth, extent);
			circleLayer.setZIndex(maxZIndex);
			this.props.slidemap.addLayer(circleLayer);
			this.circleLayerRef.current = circleLayer;
		}
		let el = document.getElementsByClassName('ol-control ol-gridreference ol-unselectable')[0];
		el && el.remove();
	}

	drawCircleLayer(fullHeight, gridRows, gridCols, fullWidth, extent) {
		let circleColor = "blue";
		if (this.props.gridState.color.toLowerCase() === "#8ed1fc" || this.props.gridState.color.toLowerCase() === "#0693e3") {
			circleColor = "#eb144c";
		}

		let squareSideLength = (this.props.gridState.spacing) / this.props.uperpixel;
		const vectorSource = new VectorSource();
		let startY = fullHeight - squareSideLength;
		let radius = squareSideLength;
		for (let i = 0; i < gridRows / 2; i++) {
			let startX = squareSideLength;
			for (let j = 0; j < gridCols / 2 ; j++) {
				if (startX < fullWidth && startY - radius > 0) {
					const circle = new Circle([startX, startY], radius); // Modify center and radius as needed
					const circleFeature = new Feature(circle);
					// Add the feature to the vector source
					vectorSource.addFeature(circleFeature);
					startX += 2 * radius;
				}
			}
			startY = startY - 2 * radius;
		}

		return new VectorLayer({
			style: new Style({
				stroke: new Stroke({
					color: circleColor,
					width: this.props.gridState.width,
				}),
			}),
			minResolution: 0,
			extent,
			source: vectorSource,
		});
	}

	drawGraticule = () => {
		let gratRef = new Graticule({
			projection: this.props.slidemap.getView().getProjection(),
			style: new Style({
				stroke: new Stroke({
					color: this.props.gridState.color,
					width: this.props.gridState.width,
				}),
				text: new Text({
					stroke: new Stroke({
						color: '#fff',
					}),
				})
			}),
			step: Math.round(this.props.gridState.spacing / this.props.uperpixel),
			stepCoord: this.props.gridState.stepCord,
		});
		this.props.slidemap.addControl(gratRef);
	}


	componentDidUpdate(prevProps, prevState, snapshot) {
		if (!isOpenLayersMap(this.props.slidemap)) return;
		let circleLayer = this.circleLayerRef.current;
		removeGridControls(this.props.slidemap);
		if (this.props.slidemap && circleLayer) {
			this.props.slidemap.removeLayer(circleLayer);
		}

		if ((prevProps.gridState !== this.props.gridState) && this.props.gridState.grid)
			this.props.gridState.dynamic ? this.drawGraticule() : this.drawGrid();
	}

	render() {
		let componentDisabled = !this.props.gridState.dynamic && (this.props.displaySetting || {})["rotation"] % 360 > 0;
		const gridButtonStyling = {
			color: this.props.gridState.grid ?
				morphleBaseTheme1.palette.headBarIcon.secondary :
				morphleBaseTheme1.palette.headBarIcon.primary,
			opacity: componentDisabled ? 0.6 : 1,
		}
		const mobileGridStyling = {
			backgroundColor: '#330470',
			color: this.props.gridState.grid ?
				morphleBaseTheme1.palette.headBarIcon.secondary :
				morphleBaseTheme1.palette.headBarIcon.primary,
			borderRadius: '50px',
			height: '40px',
			width: '40px',
			opacity: 0.8,
			padding: '5px'
		}
		componentDisabled && notifySuccess('grid', "Static Grid disabled for non-zero Rotation");

		return <Stack direction={"row"} justifyContent="space-between" alignItems='center' onClick={() => this.disableMessage(componentDisabled)}>
			<Tooltip title={"Grid"} placement={"bottom"} className='grid-forTour'>
				<IconButton size={"small"} disabled={componentDisabled} onClick={this.toggleGrid}>
					<Grid3x3 sx={this.isMobile ? mobileGridStyling : gridButtonStyling}/>
				</IconButton>
			</Tooltip>
		</Stack>
	}
}

const mapStateToProps = (state) => {
	let {activeMapId} = state.gammaStateReducer;
	let {slidemap, gridState, displaySetting, slide} = state.mapsStateReducer[activeMapId];
	let uperpixel = 1;
	if (slide?.uperpixel){
		uperpixel = slide.uperpixel;
	}
	return {activeMapId, slidemap, uperpixel, displaySetting, gridState};
}

export default connect(mapStateToProps)(GridOverlay)
